import { Fragment, lazy, Suspense } from 'react'

import type { PlaylistThumbnailProps } from './PlaylistThumbnail'
import type { PlaylistVideoPlayerProps } from './PlaylistVideoPlayer'

const PlaylistThumbnailComponent = lazy(() => import('./PlaylistThumbnail'))
const PlaylistVideoPlayerComponent = lazy(() => import('./PlaylistVideoPlayer'))

/**
 * Lazy loaded PlaylistThumbnail component
 * @param props
 * @returns
 */
export const PlaylistThumbnailLazy = (props: PlaylistThumbnailProps) => (
  <Suspense fallback={<Fragment />}>
    <PlaylistThumbnailComponent {...props} />
  </Suspense>
)

/**
 * Lazy loaded PlaylistVideoPlayer component
 * @param props
 * @returns
 */
export const PlaylistVideoPlayerLazy = (props: PlaylistVideoPlayerProps) => (
  <Suspense fallback={<Fragment />}>
    <PlaylistVideoPlayerComponent {...props} />
  </Suspense>
)
